import { LoadedEntities, StepType } from 'kb-shared/booking/types/types';
import { getAppointmentType } from 'kb-shared/booking/utils/getters';
import { AppointmentType } from 'kb-shared/types';

import { networkClinicCopy } from './networkClinicBookingCopy';

const getLocationStepTitle = ({
  appointment,
  partnerClinicSearch,
  networkClinicBooking = false
}: {
  appointment: AppointmentType | null;
  partnerClinicSearch: string | null;
  networkClinicBooking?: boolean;
}) => {
  if (partnerClinicSearch === 'search') {
    return networkClinicBooking ? networkClinicCopy.findClinic : 'Find a Partner Clinic';
  } else if (appointment?.virtual) {
    return '';
  } else {
    return 'Great! Where would you like to meet us?';
  }
};

export const getPageTitle = ({
  stepType,
  selectedProduct,
  partnerClinicSearch,
  networkClinicBooking = false
}: {
  stepType: StepType;
  selectedProduct: LoadedEntities['selectedProduct'] | null;
  partnerClinicSearch: string | null;
  networkClinicBooking?: boolean;
}) => {
  const appointment = (selectedProduct && getAppointmentType(selectedProduct)) || null;

  switch (stepType) {
    case 'location':
      return getLocationStepTitle({ appointment, partnerClinicSearch, networkClinicBooking });
    case 'time':
      return '';
    case 'consents':
      return 'Consents';
    case 'partner':
      return 'Partner Details';
    case 'insurance':
      return 'Insurance Details';
    case 'confirm':
      return '';
    case 'success':
      return "You're all set!";
    default:
      return '';
  }
};
